import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { ModalOptions } from 'Modules'
import { MODAL_NAME } from 'Constants/ModalName'

interface ModalsState {
	modals: ModalOptions[]
}

const modalsState: ModalsState = {
	modals: [],
}

export namespace ModalsStateNS {
	export type ShowGlobalModal = PayloadAction<ModalOptions>
	export type HideGlobalModal = PayloadAction<MODAL_NAME>
	export type CleanGlobalModal = PayloadAction
}

export const modalsSlice = createSlice({
	name: 'modals',
	initialState: modalsState,
	reducers: {
		showModal: (state, action: ModalsStateNS.ShowGlobalModal) => {
			const newModals = state.modals.filter(
				(modal: ModalOptions): boolean => modal.key !== action.payload.key
			)
			state.modals = [...newModals, action.payload]
		},
		hideModal: (state, action: ModalsStateNS.HideGlobalModal) => {
			state.modals = state.modals.filter(
				(modal: ModalOptions): boolean => modal.key !== action.payload
			)
		},
		cleanModals: (state, action: ModalsStateNS.CleanGlobalModal) => {
			state.modals = state.modals.filter((modal: ModalOptions) => modal.hideOnlyByUser)
		},
	},
})
